const {KitModule, registerModule} = window;

class PaginatedPostsList extends KitModule {
  constructor($element) {
    super($element);

    this.initialize();
  }

  /**
   * Implemented as a standalone function so it can be called again from
   * liveLoadResults()
   */
  bindEvents() {
    this.$linksMenu?.addEventListener('change', this.handleSelectLink.bind(this));

    this.$liveLoadLinks.forEach(($liveLoadLink) => {
      $liveLoadLink.addEventListener('click', this.handleLiveLoad.bind(this));
    });
  }

  async handleLiveLoad(event) {
    event.preventDefault();

    const url = new URL(event.target.href);
    url.hash = '';

    this.liveLoadResults(url, event.target);
  }

  handleSelectLink() {
    const selectedOption = this.$linksMenu.selectedOptions[0];

    if (selectedOption) {
      this.liveLoadResults(selectedOption.dataset.url);
    }
  }

  initialize() {
    this.bindEvents();
  }

  /**
   * @param {string} url
   * @param {HTMLElement} $liveLoadLink
   * @return {Promise}
   */
  async liveLoadResults(url, $liveLoadLink) {
    try {
      // Fetch the linked page, parse the results as HTML, and replace matching
      // elements on this page.
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const $remoteFeatured = doc.querySelector('[data-js-child="$featured"]');
      this.$featured?.replaceWith($remoteFeatured);

      const $remoteResults = doc.querySelector('[data-js-child="$posts"]');
      this.$posts?.replaceWith($remoteResults);

      const $remoteTabsList = doc.querySelector('[data-js-child="$tabsList"]');
      this.$tabsList?.replaceWith($remoteTabsList);

      const $remoteCategoriesList = doc.querySelector('[data-js-child="$categoriesList"]');
      this.$categoriesList?.replaceWith($remoteCategoriesList);

      delete this.$liveLoadLinks;
      delete this.$postLinks;

      this.updateChildren();
      this.bindEvents();

      if ($liveLoadLink?.dataset.scrollToFirstPost) {
        const options = {
          behavior: 'smooth',
        };
        if (this.$tabsList) {
          this.$tabsList?.scrollIntoView(options);
        } else {
          this.$postLinks?.[0].scrollIntoView(options);
        }
      }
    } catch (error) {
      /* eslint-disable-next-line */
      console.error(error);

      // If fetching remote results fails for any reason, tell the browser to
      // move on to the originally linked page.
      window.location.href = url;
    }
  }

  unmount() {
    //
  }
}

registerModule('PaginatedPostsList', PaginatedPostsList);
